const normalizeStatusCode = (statusCode: number): number => statusCode;

export { normalizeStatusCode };
